{% block sw_cms_element_acris_blog_title_preview %}
    <div class="sw-cms-el-preview-acris-blog-title">
        <h1>{{ $tc('acris-blog.elements.blogTitle.preview.title') }}</h1>
    </div>
{% endblock %}